import {
  PolarAngleAxis,
  PolarGrid,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from "recharts";

export default function ScoreRadar({ scores }) {
  if (!scores) return null;
  const data = [
    { pillar: "Views / Sub", value: scores.views_to_sub },
    { pillar: "Faceless", value: scores.faceless_potential },
    { pillar: "Evergreen", value: scores.evergreen_value },
    { pillar: "Monetization", value: scores.monetization_potential },
    { pillar: "Easy Prod", value: scores.production_difficulty },
  ];
  return (
    <div className="w-full h-72 min-h-[288px]">
      <ResponsiveContainer width="100%" height="100%" minHeight={280}>
        <RadarChart data={data} outerRadius="75%">
          <PolarGrid stroke="#27272a" strokeDasharray="2 4" />
          <PolarAngleAxis
            dataKey="pillar"
            tick={{
              fill: "#a1a1aa",
              fontSize: 11,
              fontFamily: "IBM Plex Mono, monospace",
              letterSpacing: "0.05em",
            }}
          />
          <Radar
            name="score"
            dataKey="value"
            stroke="#facc15"
            fill="#facc15"
            fillOpacity={0.25}
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
